// extracted by mini-css-extract-plugin
module.exports = {"HomeProductList":"HomeProductList_HomeProductList__OFAi_"};